import { SettingsApiModel } from '../../../types/models/settings.model';
import { UpdateSettingsApiRequest } from '../../../types/requests/settings/update-settings.request';
import { client } from './client';

export const getSettings = () => client.get<SettingsApiModel>(`/settings`);

export const updateSettings = (params: UpdateSettingsApiRequest) =>
  client.patch<SettingsApiModel>('/settings', params, { headers: { 'Content-Type': 'multipart/form-data' } });
